"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onSeeked;
function onSeeked(event) {
  this._playerState.seeking = false;
  this._playerState.temporaryMarkerWhileSeeking = undefined;
  this.emit('seeked', event);
  if (this._playerState.paused) {
    this.pause(true);
  }
}